import Flickity from 'flickity';
import {
  stickyClass,
  scrollToSection
} from '../../utilities/helpers';

export function slider(container) {

   
  // console.log("container",container);

  var $ = $ || jQuery, // added to see solve jquery issue
    dragIgnoreClickDelay = 75,
    dragTimeout = false,
    dragging = false,
    SliderContainerEl,
    SliderNavEl,
    SliderEl = container.querySelector(".slider"); // review - because still container is the barba container
  
  if (SliderEl === null) {
    // console.log("SliderEl is null");
    return;
  } else {
    SliderContainerEl = SliderEl.querySelector(".slider__container");   
  }

  if (SliderContainerEl !== null) {
    var slideCount = SliderContainerEl.dataset.slideCount;
    // console.log("slideCount", slideCount);

    if (slideCount >= 2) {
      SliderNavEl = SliderEl.querySelector(".slider__nav"); 
    } else {
      SliderNavEl = false;
      // console.log("slideCount less thab 2? - is:", slideCount);
    }

    var projectFlickity = new Flickity(SliderContainerEl, {
      autoPlay: false,
      prevNextButtons: false,
      pageDots: false,
      draggable: false, // allowing this fucks up the usability of the revit layers  
      wrapAround: true,
      selectedAttraction: 0.01,
      friction: 0.2,
      // accessibility: true,    
      resize: true, // reeview
      // cellAlign: 'center',
      percentPosition: false,
      watchCSS: false, // review this - I don't think we need to destroy via css?
      on: {
        dragStart: function () {
          SliderContainerEl.style.pointerEvents = 'none'
          // console.log("drag START");
          clearTimeout(dragTimeout);
          dragging = true;
        },
        dragEnd: function () {
          SliderContainerEl.style.pointerEvents = 'all'

          dragTimeout = setTimeout(
            function () {
              dragging = false;
            },
            dragIgnoreClickDelay
          );

        },
        activate: function () {
          // console.log("project & client slideshow activate");
        },
        ready: function () {
          // console.log("project & client slideshow ready");
        }

      }
    });

    if (SliderNavEl !== false) {

      // console.log("SliderNavEl", SliderNavEl)

      SliderNavEl.querySelector(".slider__nav-arrows--next").addEventListener("click", function () {
        projectFlickity.next();
      });

      SliderNavEl.querySelector(".slider__nav-arrows--previous").addEventListener("click", function () {
        projectFlickity.previous();
      });

      SliderNavEl.querySelectorAll(".slider__nav-dot").forEach(dot => {
        dot.addEventListener("click", function () {
          var navIndex = this.getAttribute("data-dot-index");
          projectFlickity.select(navIndex);
        });
      });

      stickyClass(SliderNavEl); // review this

    }

  }

} //export default function init()